import { isIOS } from 'mini-device-utils/lib/utils/isIOS';
import { isMiniFeatureEnabled } from 'owa-mini-feature-flags';
import { isMiniHostAppFeatureEnabled } from 'mini-hostapp-feature-flags/lib/isMiniHostAppFeatureEnabled';

export function isRewardsFeatureEnabled(): boolean {
    // return true if the local override flag is added
    if (isMiniFeatureEnabled('mini-rewards-enabled')) {
        return true;
    }

    // return false if the user is on iOS
    if (isIOS()) {
        return false;
    }

    // return true if host is not outlook lite and flight is enabled
    return isMiniHostAppFeatureEnabled('rewards') && isMiniFeatureEnabled('mini-rewards');
}

export function isRewardsFeatureDisabled(): boolean {
    // return false if the user is on iOS
    if (isIOS()) {
        return false;
    }

    // return true if host is not outlook lite and flight is enabled
    return isMiniHostAppFeatureEnabled('rewards') && isMiniFeatureEnabled('mini-rewards-cf');
}
